import { Checkbox, Grid, List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";

import ExtensionIcon from "@material-ui/icons/Extension";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import { Fragment } from "react";
import MeditocModal from "../../../utils/MeditocModal";
import { usePerfil } from "../../../../context/PerfilContext";

export default function BotonSeleccionar() {
    const {
        listaSistemaBotones,
        modalOpenSeleccionarBotones,
        botonesSeleccionados,
        seleccionarTodoBotones,
        handleChangeBotonCheckbox,
        handleOpenSeleccionarBotones,
        handleClickSeleccionarTodoBotones,
        handleSubmitBotones,
    } = usePerfil();

    return (
        <MeditocModal
            size="small"
            title="Permisos de botones"
            open={modalOpenSeleccionarBotones}
            setopen={handleOpenSeleccionarBotones}
            okmessage="Guardar permisos"
            okfunc={handleSubmitBotones}
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <List>
                        {listaSistemaBotones.length > 0 ? (
                            <Fragment>
                                <ListItem
                                    key={0}
                                    button
                                    dense
                                    onClick={() => handleClickSeleccionarTodoBotones(!seleccionarTodoBotones)}
                                >
                                    <ListItemIcon>
                                        <Checkbox edge="start" disableRipple checked={seleccionarTodoBotones} />
                                        <FormatListBulletedIcon className="align-self-center " />
                                    </ListItemIcon>
                                    <ListItemText id={0} primary="Seleccionar todo" />
                                </ListItem>
                                {listaSistemaBotones.map((boton) => (
                                    <ListItem
                                        key={boton.iIdBoton}
                                        button
                                        dense
                                        onClick={() => handleChangeBotonCheckbox(boton)}
                                    >
                                        <ListItemIcon>
                                            <Checkbox
                                                edge="start"
                                                disableRipple
                                                checked={botonesSeleccionados.indexOf(boton) !== -1}
                                            />
                                            <ExtensionIcon className="align-self-center color-3" />
                                        </ListItemIcon>
                                        <ListItemText id={boton.iIdBoton} primary={boton.sNombre} />
                                    </ListItem>
                                ))}
                            </Fragment>
                        ) : (
                            <div className="center">(No hay más botones por agregar)</div>
                        )}
                    </List>
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
